module.exports = __webpack_public_path__ + "img/Pause_Popup_Icon.062c4f22.svg";